export const characters = [
  {
    id: "elena",
    name: "艾琳·卡特",
    enName: "Elena Carter",
    actor: "玛格丽特·斯隆",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20composed%20dark%20haired%20woman%20in%20her%20thirties%2C%20sharp%20tailored%20coat%2C%20moody%20teal%20and%20amber%20rim%20lighting%2C%20deep%20blue%20studio%20backdrop%2C%20dramatic%20shadows%2C%20editorial%20film%20still&width=600&height=800&seq=char-elena-v1&orientation=portrait",
    type: "主角",
    seasons: [1, 2, 3, 4],
    role: "调查记者 / 家族秘密的追索者",
    bio: "冷静克制的深度调查记者，为了追查哥哥失踪的真相重返故乡，逐步被卷入一场跨越两代人的家族谜局。",
    background: [
      "艾琳·卡特曾是纽约一家独立媒体最锋利的一支笔，她擅长用冷静的耐心拆开被时间封存的故事。哥哥马修在她二十岁那年离奇失踪，警方的结论只有一句“自行离开”。",
      "十年后，一封没有署名的旧信把她重新拉回北岸小镇。她以为自己只是回来求证一个答案，却发现自己早已站在整张谎言网络的正中央。",
      "她越是接近真相，越发现身边最亲近的人都在隐瞒。她必须在天平的两端——职业的真相与家人的安全——做出选择。",
    ],
    relations: [
      { name: "大卫·布莱克", relation: "旧日恋人与关键线人", charId: "david" },
      { name: "维多利亚·斯特恩", relation: "亦敌亦师的对手", charId: "victoria" },
      { name: "莉娜·莫拉莱斯", relation: "并肩作战的同事", charId: "lena" },
    ],
    episodes: ["s1e1", "s1e2", "s1e4", "s2e1", "s2e2", "s2e5", "s3e2", "s3e3", "s4e1", "s4e3", "s4e5"],
  },
  {
    id: "david",
    name: "大卫·布莱克",
    enName: "David Black",
    actor: "伊桑·莫里斯",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20weathered%20silent%20man%20in%20his%20forties%2C%20dark%20denim%20jacket%2C%20moody%20cold%20blue%20and%20amber%20lighting%2C%20deep%20navy%20studio%20backdrop%2C%20dramatic%20shadow%2C%20editorial%20film%20still&width=600&height=800&seq=char-david-v1&orientation=portrait",
    type: "主角",
    seasons: [1, 2, 3, 4],
    role: "退役警探 / 沉默的守密人",
    bio: "当年负责马修失踪案却草草结案的警探，如今在小镇经营一家五金店，守着一段不愿被翻开的过去。",
    background: [
      "大卫·布莱克曾是小北岸最受尊敬的警探，直到那桩没能查清的失踪案让他主动脱下了制服。他把警徽锁进抽屉，也把愧疚锁进了那间堆满工具箱的仓库。",
      "艾琳的归来让他无法继续沉默。他知道的比说出口的多，而他越是想保护她，就越被卷入更深的漩涡。",
      "在他粗糙的外表下，藏着一段他与卡特家族旧日的秘密——那段秘密，正是整场谜局的起点。",
    ],
    relations: [
      { name: "艾琳·卡特", relation: "想要守护又不敢靠近的人", charId: "elena" },
      { name: "马丁·格雷", relation: "旧日搭档", charId: "martin" },
      { name: "卡尔·汉森", relation: "警惕线人", charId: "karl" },
    ],
    episodes: ["s1e1", "s1e2", "s1e3", "s2e2", "s2e3", "s3e1", "s3e4", "s4e2", "s4e4", "s4e5"],
  },
  {
    id: "lena",
    name: "莉娜·莫拉莱斯",
    enName: "Lena Morales",
    actor: "索菲亚·莱恩",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20bright%20determined%20young%20latina%20woman%20with%20short%20hair%2C%20utility%20jacket%2C%20moody%20warm%20amber%20and%20cool%20blue%20lighting%2C%20deep%20slate%20backdrop%2C%20film%20still%20portrait&width=600&height=800&seq=char-lena-v1&orientation=portrait",
    type: "主角",
    seasons: [1, 2, 3, 4],
    role: "数据记者 / 团队的技术核心",
    bio: "团队里最年轻也最锐利的那一个，擅长从海量数据里捞出别人忽略的裂缝，是艾琳最信任的同伴。",
    background: [
      "莉娜·莫拉莱斯是那种在键盘声里找到节奏的人。她相信每一份被删除的文件都会留下影子，而她的工作就是把影子重新拼成文字。",
      "她最初只是艾琳的远程协作者，却因为一桩数据泄密事件被推到风暴中心，不得不从屏幕后走向现场。",
      "她乐观、直接，也常常因此撞上团队的保守。她的成长，是从“找到真相”到“承担真相”的过程。",
    ],
    relations: [
      { name: "艾琳·卡特", relation: "导师与战友", charId: "elena" },
      { name: "诺亚·凯恩", relation: "立场相左的伙伴", charId: "noah" },
      { name: "苏菲·陈", relation: "信任的线人", charId: "sophie" },
    ],
    episodes: ["s1e2", "s1e5", "s2e1", "s2e4", "s3e2", "s3e5", "s4e1", "s4e4"],
  },
  {
    id: "victoria",
    name: "维多利亚·斯特恩",
    enName: "Victoria Stern",
    actor: "海伦·阿斯特",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20elegant%20imposing%20older%20woman%20in%20a%20structured%20dark%20suit%2C%20icy%20poised%20expression%2C%20moody%20deep%20blue%20and%20amber%20lighting%2C%20dark%20backdrop%2C%20editorial%20film%20still&width=600&height=800&seq=char-victoria-v1&orientation=portrait",
    type: "反派",
    seasons: [1, 2, 3, 4],
    role: "斯特恩集团掌门人 / 幕后的操盘者",
    bio: "小镇真正意义上的权力中心，优雅、得体、滴水不漏。她的每一次微笑，背后都标好了价码。",
    background: [
      "维多利亚·斯特恩出身于把小镇半个世纪都写进自己名字的家族。她相信秩序，而秩序必须由懂得规则的人来维护。",
      "她与卡特家族的旧账远比表面复杂：既是旧友，也是对手，甚至可能是那场失踪案唯一完整的见证者。",
      "她从不高声说话，却让所有人都不敢打断她。她真正的武器不是权力，而是耐心。",
    ],
    relations: [
      { name: "艾琳·卡特", relation: "试图收编的棋子", charId: "elena" },
      { name: "伊莎贝尔·罗斯", relation: "得力却危险的副手", charId: "isabel" },
      { name: "杰克·雷诺兹", relation: "被授意的执行者", charId: "jack" },
    ],
    episodes: ["s1e3", "s1e5", "s2e3", "s2e5", "s3e1", "s3e3", "s4e2", "s4e5"],
  },
  {
    id: "jack",
    name: "杰克·雷诺兹",
    enName: "Jack Reynolds",
    actor: "卢卡斯·维恩",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20tough%20square%20jawed%20man%20in%20his%20thirties%2C%20dark%20work%20jacket%2C%20hard%20cold%20expression%2C%20moody%20blue%20and%20amber%20lighting%2C%20deep%20navy%20backdrop%2C%20film%20still%20portrait&width=600&height=800&seq=char-jack-v1&orientation=portrait",
    type: "配角",
    seasons: [1, 2, 3],
    role: "斯特恩集团的安保主管",
    bio: "忠诚、沉默、执行力极强，是维多利亚最锋利的刀。但他心里也藏着一笔没还清的人情债。",
    background: [
      "杰克·雷诺兹把“服从”当成一种生存方式。他从军队退役后直接进入斯特恩集团，用十年时间换来一句“最靠得住的人”。",
      "他负责让不该出现的东西消失，包括人。可当命令与良心第一次碰撞，他发现自己并没有想象中那么坚固。",
      "他与大卫之间有一段无人知晓的旧交，这段交情会在最意想不到的时刻改写局势。",
    ],
    relations: [
      { name: "维多利亚·斯特恩", relation: "效忠的雇主", charId: "victoria" },
      { name: "大卫·布莱克", relation: "旧日恩怨的对手", charId: "david" },
    ],
    episodes: ["s1e3", "s1e4", "s2e3", "s2e5", "s3e1", "s3e4"],
  },
  {
    id: "noah",
    name: "诺亚·凯恩",
    enName: "Noah Kane",
    actor: "丹尼尔·福斯特",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20thoughtful%20man%20with%20glasses%20and%20a%20knit%20sweater%2C%20gentle%20wary%20expression%2C%20moody%20soft%20amber%20and%20blue%20lighting%2C%20dark%20slate%20backdrop%2C%20film%20still&width=600&height=800&seq=char-noah-v1&orientation=portrait",
    type: "配角",
    seasons: [2, 3, 4],
    role: "镇档案室管理员 / 理想的守门人",
    bio: "守着小镇所有纸质档案的年轻人，他相信记录就是权力，也因此成了所有人争夺的对象。",
    background: [
      "诺亚·凯恩是那种安静到容易被忽略的人，直到你发现全镇的秘密都要经过他手里那串钥匙。",
      "他最初只是希望还原一段被改写的历史，却在过程中逐渐变得偏执，开始分不清“保护真相”与“占有真相”的界限。",
      "他与莉娜的立场会从合作走向对立，这段分歧也是第二季最关键的情感线之一。",
    ],
    relations: [
      { name: "莉娜·莫拉莱斯", relation: "从战友到对手", charId: "lena" },
      { name: "苏菲·陈", relation: "意外的盟友", charId: "sophie" },
    ],
    episodes: ["s2e1", "s2e2", "s3e2", "s3e5", "s4e1", "s4e3"],
  },
  {
    id: "sophie",
    name: "苏菲·陈",
    enName: "Sophie Chen",
    actor: "林嘉怡",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20quiet%20perceptive%20asian%20woman%20in%20a%20dark%20cardigan%2C%20watchful%20calm%20expression%2C%20moody%20teal%20and%20amber%20lighting%2C%20deep%20blue%20backdrop%2C%20editorial%20film%20still&width=600&height=800&seq=char-sophie-v1&orientation=portrait",
    type: "配角",
    seasons: [2, 3, 4],
    role: "小镇诊所护士 / 沉默的见证者",
    bio: "在小诊所里见过太多人的伤口，包括那些从来不愿意被记录的伤口。她是这场谜局中最安静的记录者。",
    background: [
      "苏菲·陈在镇诊所工作了八年，她记得每一个深夜推开门的脸，也记得那些不该被写进病历的事。",
      "她本想做一个旁观者，直到某份旧病历让她意识到，沉默同样是一种选择，而且代价高昂。",
      "她的谨慎与善良，是艾琳团队里最容易被低估，却最不可或缺的一环。",
    ],
    relations: [
      { name: "莉娜·莫拉莱斯", relation: "彼此信任的线人关系", charId: "lena" },
      { name: "卡尔·汉森", relation: "诊所里的旧识", charId: "karl" },
    ],
    episodes: ["s2e4", "s2e5", "s3e3", "s3e5", "s4e3", "s4e4"],
  },
  {
    id: "martin",
    name: "马丁·格雷",
    enName: "Martin Gray",
    actor: "亚瑟·贝克",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20tired%20older%20police%20chief%20with%20grey%20stubble%20and%20a%20shirt%20and%20tie%2C%20weary%20expression%2C%20moody%20cold%20blue%20and%20amber%20lighting%2C%20dark%20backdrop%2C%20film%20still&width=600&height=800&seq=char-martin-v1&orientation=portrait",
    type: "配角",
    seasons: [1, 2, 3],
    role: "现任警长 / 夹在规则与人情之间",
    bio: "大卫当年的搭档，如今坐上警长之位。他想维持小镇表面的平静，却发现平静本身就是一种需要掩盖的谎。",
    background: [
      "马丁·格雷把一生都交给了这座小镇的秩序。他比谁都清楚哪些案卷不该被重开，也比谁都清楚那些案卷里的漏洞。",
      "他对大卫既有旧情，也有旧怨——当年那桩案子，是两个人共同的伤口，也是彼此心照不宣的禁区。",
      "当艾琳的调查逼近临界点，他必须在“维护安稳”与“伸张正义”之间选一次边。",
    ],
    relations: [
      { name: "大卫·布莱克", relation: "旧日搭档", charId: "david" },
      { name: "维多利亚·斯特恩", relation: "勉强的合作者", charId: "victoria" },
    ],
    episodes: ["s1e4", "s2e2", "s2e5", "s3e1", "s3e4"],
  },
  {
    id: "isabel",
    name: "伊莎贝尔·罗斯",
    enName: "Isabel Ross",
    actor: "诺拉·海伍德",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20sharp%20ambitious%20blonde%20woman%20in%20a%20sleek%20dark%20dress%2C%20cold%20confident%20stare%2C%20moody%20icy%20blue%20and%20amber%20lighting%2C%20deep%20navy%20backdrop%2C%20editorial%20film%20still&width=600&height=800&seq=char-isabel-v1&orientation=portrait",
    type: "反派",
    seasons: [3, 4],
    role: "斯特恩集团法务总监 / 野心家",
    bio: "维多利亚最信任的副手，也是最想取代她的人。她懂得如何用规则本身，去瓦解制定规则的人。",
    background: [
      "伊莎贝尔·罗斯从法学院第一名走到集团核心，用的从来不只是能力。她相信权力不该被继承，而该被夺取。",
      "她表面忠于维多利亚，暗地里却在收拢每一份足以翻盘的材料，等待一个最合适的时机。",
      "她的登场让原本稳定的权力天平开始倾斜，也让艾琳第一次看到了“敌人内部”的裂缝。",
    ],
    relations: [
      { name: "维多利亚·斯特恩", relation: "伺机取代的上司", charId: "victoria" },
      { name: "杰克·雷诺兹", relation: "试图拉拢的执行者", charId: "jack" },
    ],
    episodes: ["s3e3", "s3e5", "s4e2", "s4e5"],
  },
  {
    id: "karl",
    name: "卡尔·汉森",
    enName: "Karl Hansen",
    actor: "彼得·诺兰",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20nervous%20middle%20aged%20man%20in%20a%20fishing%20jacket%20and%20cap%2C%20anxious%20evasive%20expression%2C%20moody%20cold%20blue%20and%20amber%20lighting%2C%20dark%20harbor%20backdrop%2C%20film%20still&width=600&height=800&seq=char-karl-v1&orientation=portrait",
    type: "配角",
    seasons: [1, 2, 3, 4],
    role: "码头工人 / 良心不安的边缘人",
    bio: "在码头干了半辈子的普通人，知道一点、害怕很多。他的犹豫和愧疚，是整条线索上最关键的一环。",
    background: [
      "卡尔·汉森从没想过要参与任何“大事”，他只是那天刚好值班，刚好看见了不该看见的东西。",
      "此后每一次追问都让他退缩，每一次沉默都让他更清楚自己成了共犯。他想赎罪，又怕代价。",
      "他胆小、真实、让人又气又心疼，而正是这样的人，往往握着最接近真相的钥匙。",
    ],
    relations: [
      { name: "大卫·布莱克", relation: "警惕又依赖的线人关系", charId: "david" },
      { name: "苏菲·陈", relation: "诊所旧识", charId: "sophie" },
    ],
    episodes: ["s1e2", "s1e3", "s2e3", "s3e4", "s4e2"],
  },
];